// extracted by mini-css-extract-plugin
export default {"reminder":"gs6sM"};